import React, { Component } from 'react';
import styled from 'styled-components';

const Divider = styled.div`
  width: 100%;
  margin: 4px 0px;
  border-bottom: ${props => `1px solid ${props.theme.colors.grey40}`};
`;

const Container = styled.div`
  margin: 0 16px;
`;

export default class OverviewCardSubDivider extends Component {
  render() {
    return (
      <Container>
        <Divider />
      </Container>
    );
  }
}
